import * as React from 'react';
import {useEffect, useRef, useState} from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import { Divider, IconButton, Select, Typography, FormControl, InputLabel, MenuItem} from '@mui/material';
import {getNow, printVariable, searchSchool} from '@util/helper';
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import moment from 'moment';
import useDelegate from "@hooks/useDelegate";
import Autocomplete from "@mui/material/Autocomplete";
import {Grid} from "@mui/material/";
import MUITable from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import useAlert from "@hooks/useAlert";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import ConfirmDialog from "@components/ConfirmDialog";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined"
import { MAX_FILE_SIZE } from '@util/constant';
import { styled } from '@mui/material/styles';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const ProfileDirectPartApply = ({record, relationList, dialogHandler, callback}) =>  {
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()

  // redux
  const account = useSelector(state => state.accountReducer);
  const schola = useSelector(state => state.scholaReducer);
  const dateFormat = 'YYYY-MM-DD HH:mm:ss';
  const schools = useSelector(state => state.schoolReducer)

  const [schoolList, set_schoolList] = useState([])
  const [data, set_data] = useState({})
  const [word, set_word] = useState('')
  const {alert, renderAlert} = useAlert()
  const searchButtonRef = useRef(null)
  const [files, set_files] = useState([])
  const handleClose = (event, reason)=> {
    if(reason && reason === "backdropClick") {
      return 
    }
    else {
      dialogHandler[1](false)
      if(callback) {
        callback()
      }
    }
  }

  const fetchCompanySchoolRelationList = async(schoolIdList) => {
    const url = `/rltn/company/schoolids/`
    const resp = await WebService.post(url, schoolIdList)

    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return []

    }
    const repMessage = JSON.parse(resp.repMessage)
    return JSON.parse(repMessage.records)
  }

  const canSubmit = () => {
    return data.id && files.length > 0
  }

  const validate = async() => {}

  const checkDup = async () => {
    const url = `/rltn/school/direct/${data.id}/S001` 
    const resp = await WebService.get(url)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return false
    }
    else {
      const repMessage = JSON.parse(resp.repMessage) 
      const records = JSON.parse(repMessage.records)
      console.log('records', records)
      if(records.length > 0) {
        alert('이미 직영 신청/등록중인 학교입니다.')
        return false
      }
    }
    return true
  }

  const onSubmit = async() => {
    const schoolUserRltn = {
      id: -1, userId: account.user.id, schoolId: data.id, rltnCode:'S001', statCode:'S001', regTime: getNow()
    }
    const rltnData = {
      schoolUserRltn: JSON.stringify(schoolUserRltn)
    }
    
    const jsonData = JSON.stringify(rltnData)
    const formData = new FormData()
    files.forEach((file, index) => {
      if (file instanceof File) {
        // formData.append(`files`, file)
        const f = new File([file], file.name, { type: file.type }) 
        formData.append(`files`, f)
      }
    })
    formData.append("body", new Blob([jsonData], { type: "application/json" }))

    const url = `/rltn/school/direct/request/`
    openIndicator()
    const resp = await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    closeIndicator()
    console.log('resp', resp)
    if(resp.data.repCode === 'ack') {
      alert('신청되었습니다.', () => {
        handleClose()
      })
    }
    else {
      alert(resp.data.repMessage)
    }
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      searchButtonRef.current.click();
    }
  };

  const onLoad =  async() => {
    openIndicator()
    closeIndicator()
  }

  const onSearch = async () => {
    const schools = await searchSchool(word)
    const schoolIdList = schools.map(r => r.id)
    const freshList = await fetchCompanySchoolRelationList(schoolIdList)
    for(const r of schools) {
      const found = freshList.find(c => c.school.id === r.id)
      if(found) {
        r.companyName = found.company.name
      }
      else {
        r.companyName = '없음'
      }
    }
    set_schoolList(schools)
  }

  const onChangeFile = (e) => {
    const files = Array.from(e.target.files)
    for(const file of files) {
      if(file.size > MAX_FILE_SIZE * 10) {
        alert('파일 크기는 10MB 이하만 가능합니다.') 
        return
      }
    }
    set_files(files)
  }

  useEffect(() => {
    if(dialogHandler[0]) {
      onLoad()
    }
  },[dialogHandler[0]])

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  return (
    <Fragment>
      <Dialog record={record} open={dialogHandler[0]} onClose={handleClose} maxWidth='md' fullWidth>
        <DialogTitle>
          <Typography variant='h5' align='center'>
            직영 학교 등록 신청 
          </Typography>
          <Divider></Divider>
        </DialogTitle>
        <DialogContent>
          <br/>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <TextField
                    fullWidth
                    label='학교명'
                    onChange={ (e) => {
                      set_word(e.target.value.trim())
                    }}
                  />
                </Grid>
                <Grid item xs={4} sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                  <Button ref={searchButtonRef} onClick={onSearch}>검색</Button>
                </Grid>
              </Grid>

              <Divider sx={{margin:1, borderBottomWidth:0,}}/>
              <Box sx={{ width: '100%', minHeight:300 }}>
                <MUITable >
                  <TableHead>
                    <TableRow>
                      <TableCell>선택</TableCell>
                      <TableCell>학교</TableCell>
                      <TableCell>위탁업체</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      schoolList.map((row, index) => {
                        return(
                          <TableRow key={index} onClick={() => set_data(row)}>
                            <TableCell>
                              <input
                                type='radio'
                                name='rltn'
                                checked={row.id === data.id}
                                value = {data.id}
                                onChange={(e) => {
                                }}
                              />

                            </TableCell>
                            <TableCell>
                              {row.label}
                            </TableCell>
                            <TableCell>
                              {row.companyName}
                            </TableCell>
                          </TableRow>
                        )
                      })
                    }
                  </TableBody>
                </MUITable>
              </Box>

            </Grid>
           <Grid item xs={12}>
             <Typography variant='h6' align='center'>첨부 서류</Typography>
             <Divider />
           </Grid>
            <Grid item xs={8} sx={{display:'flex', flexDirection:'column', alignItems:'flex-end', }}>
              {
                files.map(file => (
                  <Typography variant='body2'>{file.name}</Typography>
                ))
              }
            </Grid>
            <Grid item xs={4} sx={{display:'flex', flexDirection:'column', alignItems:'flex-end', }} >
              <Button component="label" variant="contained" startIcon={<AttachFileOutlinedIcon />}>
                학교 관계 서류(재직증명서 등)
                <VisuallyHiddenInput type="file" 
                  accept='.jpg, .png, .pdf, .doc, .ppt' 
                  multiple
                  onChange={e => {
                    onChangeFile(e)
                }} />
              </Button>
            </Grid>
          </Grid>
          <br/>
        </DialogContent>
        <DialogActions>

          <Button onClick={handleClose}>
            닫기
          </Button>
          <ConfirmDialog
            btn={<Button disabled={!canSubmit()} variant='contained' color={'primary'}>신청</Button>}
            title={'알림'}
            content={'해당 학교를 직영학교로 신청하시겠습니까?'}
            bc={'primary'}
            preHandle={() => {
              return checkDup()
            }}
            perform={() => {
              onSubmit()
            }}
          />
        </DialogActions>
      </Dialog>
      {renderIndicator()}
      {renderAlert()}
    </Fragment>
  )
}

export default ProfileDirectPartApply
